import React, { useState, useEffect } from 'react';
import CommonServices from '../../services/ComanServices';
import useAsync from '../../hooks/useAsync';

function Day() {
  const { data, error, isLoading } = useAsync(CommonServices.getDay);

  const [formValues, setFormValues] = useState({
    weeklyDay: '',
    monthlyDay: '',
    indiaVix:'',
  });

  useEffect(() => {
    if (data?.data) {
      setFormValues({
        weeklyDay: data.data.weekly_day ?? data.data.weeklyDay ?? '',
        monthlyDay: data.data.monthly_day ?? data.data.monthlyDay ?? '',
        indiaVix: data.data.india_vix ?? data.data.indiaVix ?? '',
      });
    }
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const payload = {
        weeklyDay: Number(formValues.weeklyDay),
        monthlyDay: Number(formValues.monthlyDay),
        indiaVix: formValues.indiaVix,
      };
      await CommonServices.updateDay(payload);
      alert('Day details updated successfully');
    } catch (error) {
      console.error('Failed to update Day details', error);
      alert('Failed to update Day details');
    }
  };
  

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Day details</div>;

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Day</h2>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Weekly Day</label>
                    <input
                      type="number"
                      name="weeklyDay"
                      className="form-control"
                      value={formValues.weeklyDay}
                      onChange={handleInputChange}
                      required
                      min={1}
                      max={7}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Monthly Day</label>
                    <input
                      type="number"
                      name="monthlyDay"
                      className="form-control"
                      value={formValues.monthlyDay}
                      onChange={handleInputChange}
                      required
                      min={1}
                      max={31}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>India Vix</label>
                    <input
                      type="number"
                      name="indiaVix"
                      className="form-control"
                      value={formValues.indiaVix}
                      onChange={handleInputChange}
                      required
                      
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Day;
